import {
  DeviceMobileIcon,
  DownloadIcon,
  ExternalLinkIcon,
} from '@heroicons/react/outline';
import React from 'react';

interface ActionIconsProps {
  binaryDownloadUri?: string;
  firebaseConsoleUri?: string;
  testingUri?: string;
  fileName?: string;
  size?: 'sm' | 'md' | 'lg';
}

const ActionIcons: React.FC<ActionIconsProps> = ({
  binaryDownloadUri,
  firebaseConsoleUri,
  testingUri,
  fileName = 'app-release',
  size = 'sm',
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'md':
        return 'w-8 h-8 p-1.5';
      case 'lg':
        return 'w-10 h-10 p-2';
      default:
        return 'w-7 h-7 p-1.5';
    }
  };

  const linkBaseClasses = `
    inline-flex items-center justify-center rounded-md border border-gray-300 dark:border-gray-600
    bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 
    hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-800 dark:hover:text-gray-100
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
    transition-colors duration-150 no-underline ${getSizeClasses()}
  `;

  return (
    <div className="flex items-center gap-1">
      {/* Binary Download */}
      {binaryDownloadUri && (
        <a
          href={binaryDownloadUri}
          download={fileName}
          className={linkBaseClasses}
          title="Download APK/IPA (Right-click to copy link)"
        >
          <DownloadIcon className="w-4 h-4" />
        </a>
      )}

      {/* Firebase Console */}
      {firebaseConsoleUri && (
        <a
          href={firebaseConsoleUri}
          target="_blank"
          rel="noopener,noreferrer"
          className={linkBaseClasses}
          title="Firebase Console (Right-click to copy link)"
        >
          <ExternalLinkIcon className="w-4 h-4" />
        </a>
      )}

      {/* Testing Link */}
      {testingUri && (
        <a
          href={testingUri}
          target="_blank"
          rel="noopener,noreferrer"
          className={linkBaseClasses}
          title="Testing Link (Right-click to copy link)"
        >
          <DeviceMobileIcon className="w-4 h-4" />
        </a>
      )}

      {/* No actions available */}
      {!binaryDownloadUri && !firebaseConsoleUri && !testingUri && (
        <span className="text-xs text-gray-400 dark:text-gray-500">
          No downloads
        </span>
      )}
    </div>
  );
};

export default ActionIcons;
